function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.8843 7.27592H10.5V46.9377H42.8843V7.27592Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.701 10.3692H12.6831V44.209H40.701V10.3692Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.3347 4.72902H31.0585C30.3308 3.09161 28.6934 2 26.6921 2C24.8728 2 23.2354 3.09161 22.3257 4.72902H17.0496C16.5038 4.72902 15.958 5.27483 15.958 5.82064V11.6426C15.958 12.1884 16.5038 12.7341 17.0496 12.7341H36.1527C36.6985 12.7341 37.2444 12.1884 37.2444 11.6426V5.82064C37.4263 5.0929 36.8805 4.72902 36.3347 4.72902Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6921 9.09544C27.8978 9.09544 28.8753 8.11801 28.8753 6.91226C28.8753 5.7065 27.8978 4.72902 26.6921 4.72902C25.4863 4.72902 24.5089 5.7065 24.5089 6.91226C24.5089 8.11801 25.4863 9.09544 26.6921 9.09544Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7788 16.7369H15.5942V20.9213H19.7788V16.7369Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 17.2828H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 20.3756H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7788 24.5596H15.5942V28.7441H19.7788V24.5596Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 25.1055H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 28.0162H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7788 32.2012H15.5942V36.3857H19.7788V32.2012Z",
  fill: "white",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 32.7471H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5078 35.8399H37.4264",
  stroke: "#172B4D",
  strokeWidth: 1.75,
  strokeMiterlimit: 10
});

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dashboard.2753aad0.svg";
export { ForwardRef as ReactComponent };